import { FlexColumn, MaterialIcon } from '@gorila-shared-ui/components';
import { Block } from 'baseui/block';
import { FlexGrid, FlexGridItem } from 'baseui/flex-grid';
import { LabelMedium, ParagraphSmall } from 'baseui/typography';
import { generatePath, useNavigate, useParams } from 'react-router-dom';
import { FLEET_DOWNLOADS_PAGE } from '../../../constants/fleet';
import { FLEET_REPORT_TYPE_OPTIONS } from '../../../constants/reports';
import { useStyles } from '../../../hooks/useStyles';

function FleetReportTypeChooser() {
  const { theme, css } = useStyles();
  const navigate = useNavigate();
  const { id: workspaceId } = useParams();
  const cardStyles = (minHeight = '100px') =>
    css({
      padding: theme.sizing.scale600,
      ...theme.borders.border300,
      borderRadius: theme.borders.popoverBorderRadius,
      height: 'auto',
      minHeight,
      width: '100%',
      cursor: 'pointer',
      transition: 'all 0.3s ease',
      position: 'relative',
      overflow: 'hidden',
      opacity: 1,
      ':hover': {
        background: theme.colors.buttonTertiaryHover,
      },
    });
  const iconWrapperStyles = css({
    width: '28px',
    height: '28px',
    borderRadius: '50%',
    ...theme.borders.border600,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: theme.sizing.scale300,
    flexShrink: 0,
  });

  const onReportTypeClick = (route: string) => {
    navigate(generatePath(route, { id: workspaceId }));
  };

  const onGoToDownloads = () => {
    navigate(generatePath(FLEET_DOWNLOADS_PAGE.route, { id: workspaceId }));
  };

  return (
    <FlexColumn classNames={css({ overflowY: 'auto' })}>
      <FlexGrid
        flexGridColumnCount={[1, 1, 1, 3, 4, 5]}
        flexGridColumnGap="scale600"
        flexGridRowGap="scale600"
        overflow="visible"
      >
        {FLEET_REPORT_TYPE_OPTIONS.map((reportType) => (
          <FlexGridItem
            display="flex"
            key={reportType.id}
            onClick={() => onReportTypeClick(reportType.route)}
            style={{ position: 'relative' }}
          >
            <Block className={cardStyles()}>
              <Block className={iconWrapperStyles}>
                <MaterialIcon
                  name={reportType.icon}
                  size="18px"
                  color={theme.colors.contentSecondary}
                />
              </Block>
              <LabelMedium style={{ fontWeight: theme.typography.HeadingSmall.fontWeight }}>
                {reportType.label}
              </LabelMedium>
              <ParagraphSmall margin={0}>{reportType.description}</ParagraphSmall>
            </Block>
          </FlexGridItem>
        ))}
        <FlexGridItem
          display="flex"
          onClick={onGoToDownloads}
        >
          <Block className={cardStyles()}>
            <Block className={iconWrapperStyles}>
              <MaterialIcon
                name="cloud_download"
                size="18px"
                color={theme.colors.contentSecondary}
              />
            </Block>
            <LabelMedium style={{ fontWeight: theme.typography.HeadingSmall.fontWeight }}>
              Descargas reportes
            </LabelMedium>
            <ParagraphSmall margin={0}>Revisa y descarga los reportes generados.</ParagraphSmall>
          </Block>
        </FlexGridItem>
      </FlexGrid>
    </FlexColumn>
  );
}

export default FleetReportTypeChooser;
